/*
 * Public API Surface of ngx-mat-dynamic-table
 */

export * from './lib/ngx-mat-dynamic-table.service';
export * from './lib/ngx-mat-dynamic-table.component';
export * from './lib/ngx-mat-dynamic-table.module';

export { DynamicTableComponent, DynamicTableColumnDefinition, DynamicTableCellClickResult } from './lib/components/dynamic-table/dynamic-table.component';
export { DynamicTableContainerComponent } from './lib/components/dynamic-table-container/dynamic-table-container.component';
export { XlsxTableExportComponent } from './lib/components/xlsx-table-export/xlsx-table-export.component';